/** אירוע לרענון ידני של SystemGlobalBanner (באנר הודעות מערכת בכותרת) */
export const SYSTEM_GLOBAL_BANNER_REFRESH_EVENT = 'berry:system-global-banner-refresh';

type RefreshDetail = { resolve?: () => void; clearDismiss?: boolean };

export type RequestSystemGlobalBannerRefreshOptions = {
  /** ברירת מחדל true — מסיר סגירת באנר מ-localStorage כדי להציג שוב הודעה פעילה */
  clearDismiss?: boolean;
};

/**
 * מבקש מ־SystemGlobalBanner לטעון מחדש את סטטוס המערכת (אותו JSON כמו בטעינה האוטומטית).
 * מחזיר Promise שמסתיים כאשר הטעינה הסתיימה, או אחרי timeout אם אין מאזין (למשל מחוץ ל־MainLayout).
 */
export function requestSystemGlobalBannerRefresh(options?: RequestSystemGlobalBannerRefreshOptions): Promise<void> {
  return new Promise((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeoutId);
      resolve();
    };
    const timeoutId = window.setTimeout(finish, 15_000);
    const clearDismiss = options?.clearDismiss !== false;
    window.dispatchEvent(
      new CustomEvent<RefreshDetail>(SYSTEM_GLOBAL_BANNER_REFRESH_EVENT, {
        detail: { resolve: finish, clearDismiss },
      }),
    );
  });
}
